
export const objectToDotNotation = (obj, replaceSlashes=false) => {
    const out = [];
    (function x(obj, path) {
        Object.keys(obj).forEach((k) => {
            const key = replaceSlashes ? k.replace('/', '.') : k;
            const s = path.concat([key]);
            const v = obj[k];
            if (typeof v === 'object') {
                x(v, s);
            } else {
                out.push({label: v, value: s.join('.')});
            }
        });
    })(obj, []);

    return out;
}
